import { useState } from "react";

export default function AdminBar({ onToggle }) {
  const [hovered, setHovered] = useState(false);
  const isAdmin = window.location.pathname === "/admin";

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
      height: 36, background: "#050505", borderBottom: "1px solid #1a1a1a",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "0 20px", fontFamily: "monospace",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 9, letterSpacing: "0.2em", color: "#333", textTransform: "uppercase" }}>
          Admin
        </span>
        <span style={{ color: "#1e1e1e" }}>|</span>
        <span style={{
          fontSize: 9, letterSpacing: "0.15em", textTransform: "uppercase",
          color: isAdmin ? "#ffcc33" : "#3399ff",
        }}>
          {isAdmin ? "● Editorial Control" : "● Subscriber View"}
        </span>
      </div>
      <button
        onClick={onToggle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          background: hovered ? "#111" : "none",
          border: `1px solid ${hovered ? "#2a2a2a" : "#1a1a1a"}`,
          color: hovered ? "#ccc" : "#555",
          padding: "3px 12px", borderRadius: 3, cursor: "pointer",
          fontSize: 10, fontFamily: "monospace", letterSpacing: "0.08em",
          transition: "all 0.1s",
        }}>
        {isAdmin ? "→ Subscriber View" : "→ Editorial Control"}
      </button>
    </div>
  );
}
